import '../../css/style.scss'
import {UIWFooterController} from '../ui_html/UIWFooterController'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {Sound} from '../../../shared/scripts/Sound'
import {UICheckoutPageController} from '../../../shared/scripts/ui_checkout/UICheckoutPageController'

void init()

async function init() {
    Sound.loadSounds()
    await EntryShared.initializeEntry()
    new UIWFooterController()
    new UICheckoutPageController()
    EntryShared.sendPageVisitAnalyticEvent()
}
